'use client';

import { AuthProvider } from '@/contexts/AuthContext';
import PropTypes from 'prop-types';

export default function ClientProviders({ children }) {
  return (
    <AuthProvider>
      {children}
    </AuthProvider>
  );
}

ClientProviders.propTypes = {
  children: PropTypes?.node?.isRequired
};